import BackToTop from "@/components/feature/BackToTop";
import PageMeta from "@/components/feature/PageMeta";
import SiteFooter from "@/components/feature/SiteFooter";
import SiteHeader from "@/components/feature/SiteHeader";
import { articles } from "@/mocks/articles";
import { faqs } from "@/mocks/faq";
import { siteInfo } from "@/mocks/site";
import FeaturedFeed from "./components/FeaturedFeed";
import FaqSection from "./components/FaqSection";
import HeroSection from "./components/HeroSection";
import HotRanking from "./components/HotRanking";
import PrinciplesSection from "./components/PrinciplesSection";
import SubscribeSection from "./components/SubscribeSection";
import TopicGrid from "./components/TopicGrid";
import VoicesSection from "./components/VoicesSection";

const ranked = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 8);

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: siteInfo.brand,
      url: "https://rnmka.cn/",
      description:
        "专注爆料看料与吃瓜围观的中文热点观察站，聚合全网热议话题并提供话题梳理与复盘。",
      inLanguage: "zh-CN",
    },
    {
      "@type": "Organization",
      name: siteInfo.brand,
      url: "https://rnmka.cn/",
      email: siteInfo.email,
      description: siteInfo.intro,
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      })),
    },
    {
      "@type": "ItemList",
      name: "今日热榜",
      itemListElement: ranked.map((article, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `https://rnmka.cn/article/${article.id}`,
        name: article.title,
      })),
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <PageMeta
        title="热瓜前线｜爆料看料围观聚合，吃瓜凑热闹蹲前排的热点观察站"
        description="热瓜前线是专注「爆料看料」与吃瓜围观的中文热点观察站，聚合全网最新热点，提供前排蹲点式的爆料看料围观、吃瓜凑热闹与话题复盘内容，涵盖网络热议、娱乐风向、社会百态、科技新鲜事等栏目，帮你把每一条热点看明白、看透彻。"
        keywords="爆料看料,爆料看料围观,爆料看料吃瓜,爆料看料凑热闹,爆料看料前排,热点观察"
        path="/"
        jsonLd={homeJsonLd}
      />
      <SiteHeader />
      <main>
        <HeroSection />
        <HotRanking />
        <TopicGrid />
        <FeaturedFeed />
        <PrinciplesSection />
        <VoicesSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}